import { createTracker } from 'usage-tracker';
import events from '../../events.yaml';
import { setPrimaryTracker } from 'usage-tracker-container';
import { REPORTING_TRACKER } from 'reporting-data/constants/usageTracker';
const trackerInstance = createTracker({
  events
});
setPrimaryTracker(trackerInstance, REPORTING_TRACKER);
export const usageTracker = createTracker({
  events,
  lastKnownEventProperties: ['screen', 'subscreen']
});